import { css } from '@emotion/css'
import { fontFamily, fontSize, fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto auto',
    columnGap: spacing.default,
    gridTemplateAreas: `
      "flag title edit delete"
      ". status . ."
    `,
  }),
  row: css({
    display: 'flex',
    alignItems: 'center',
  }),

  flag: css({
    gridArea: 'flag',
  }),

  unknown: css({
    gridArea: 'flag',
    marginTop: '8px',
  }),

  title: css({
    fontFamily: fontFamily.heading,
    fontSize: fontSize.default,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.4,
    color: colors.oxfordBlue,
    margin: 0,
    gridArea: 'title',
  }),

  status: css({
    gridArea: 'status',
    fontWeight: fontWeight.regular,
  }),

  permitType: css({
    gridArea: 'permitType',
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    marginTop: spacing.small,
  }),

  editButton: css({
    marginTop: spacing.small,
    gridArea: 'edit',
  }),
  deleteButton: css({
    marginTop: spacing.small,
    gridArea: 'delete',
  }),

  semiBold: css({ ...fontWeight.semiBold }),
}

export default styles
